import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Form, Alert } from "react-bootstrap";
import { toast } from "react-toastify";
import BirthdayCoupon from "./rewards-component/BirthdayCoupon";
import BogoCoupon from "./rewards-component/BogoCoupon";
import BoosterPoint from "./rewards-component/BoosterPoint";
import SizeUpgrade from "./rewards-component/SizeUpgrade";
import Header from "../../layouts/Header";
import axiosInstance from '../../api/axios';

const AddLevel = () => {
    const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
    const [skin, setSkin] = useState(currentSkin);
    const accessToken = localStorage.getItem("authToken");
    const [selectedCouponOption, setSelectedCouponOption] = useState("");
    const [levels, setLevels] = useState([]);
    const [couponsData, setCouponsData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const fetchLevelsData = async () => {
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.get("level", { headers });
            if (response?.data?.status === true) {
                setLevels(response?.data?.data?.levels);
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.error || "Failed to fetch levels.";
            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
            });
        }
    };

    const fetchCouponData = async () => {
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.get("coupons", { headers });
            if (response?.data?.status === true) {
                setCouponsData(response?.data?.data?.coupons);
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.error || "Failed to fetch coupons.";
            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
            });
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchLevelsData();
        fetchCouponData();
    }, []);

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-3 p-lg-4">
                <Container fluid>
                    <Row className="mb-2">
                        <Col>
                            <h4 className="fw-bold mb-0">Add Level Reward</h4>
                            <p className="text-muted">Select and configure rewards for different levels</p>
                        </Col>
                    </Row>

                    {isLoading ? (
                        <Row>
                            <Col className="text-center py-5">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </Col>
                        </Row>
                    ) : (
                        <Row>
                            <Col lg={selectedCouponOption ? 4 : 6} className="mx-auto">
                                <Card className="border-0 shadow-sm">
                                    <Card.Body className="p-3">
                                        <Row>
                                            <Col>
                                                <h5 className="mb-4 fw-bold text-primary">REWARD CONFIGURATION</h5>
                                            </Col>
                                            <hr />
                                        </Row>
                                        <Form.Group controlId="rewardSelect" className="mb-3">
                                            <Form.Label className="fw-semibold">
                                                Reward Type <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Select
                                                value={selectedCouponOption}
                                                onChange={(e) => setSelectedCouponOption(e.target.value)}
                                                className="form-select"
                                            >
                                                <option value="">Select reward type</option>
                                                <option value="BIRTHDAY">Birthday Coupon</option>
                                                <option value="BOGO">BOGO</option>
                                                <option value="SIZE UPGRADE">Size Upgrade</option>
                                                <option value="BOOSTER POINT">Booster Points</option>
                                                <option value="FREE COMPLIMENTARY">Free Complimentary</option>
                                            </Form.Select>
                                        </Form.Group>
                                        
                                        {!selectedCouponOption && (
                                            <Alert variant="info" className="mt-4">
                                                <i className="bi bi-info-circle-fill me-2"></i>
                                                Please select a reward type to configure its settings
                                            </Alert>
                                        )}
                                    </Card.Body>
                                </Card>
                            </Col>

                            {selectedCouponOption && (
                                <Col lg={8} className="mt-4 mt-lg-0">
                                    <Card className="border-0 shadow-sm h-100">
                                        <Card.Body className="p-4">
                                            <div className="d-flex justify-content-between align-items-center mb-4">
                                                <h5 className="fw-bold mb-0 text-capitalize">
                                                    {selectedCouponOption.toLowerCase().replace(/_/g, ' ')} Settings
                                                </h5>
                                                <button 
                                                    className="btn btn-sm btn-outline-secondary"
                                                    onClick={() => setSelectedCouponOption("")}
                                                >
                                                    <i className="bi bi-arrow-left me-1"></i> Back
                                                </button>
                                            </div>
                                            
                                            {selectedCouponOption === "BIRTHDAY" && <BirthdayCoupon levels={levels} />}
                                            {selectedCouponOption === "BOGO" && (
                                                <BogoCoupon levels={levels} couponsData={couponsData} />
                                            )}
                                            {selectedCouponOption === "SIZE UPGRADE" && (
                                                <SizeUpgrade levels={levels} couponsData={couponsData} />
                                            )}
                                            {selectedCouponOption === "BOOSTER POINT" && (
                                                <BoosterPoint levels={levels} couponsData={couponsData} />
                                            )}
                                        </Card.Body>
                                    </Card>
                                </Col>
                            )}
                        </Row>
                    )}
                </Container>
            </div>
        </React.Fragment>
    );
};

export default AddLevel;